import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { App } from "./App";
import { registerServiceWorker } from "./lib/register-service-worker";
import { initSentry } from "./observability/sentry";
import "./styles.css";

// Tell index.html's pre-boot recovery script (Sentry JAVASCRIPT-REACT-3R)
// that the entry bundle is NOT missing, so it stands down for good.
// Reaching this line means every statically-imported module above (App
// and everything it imports, register-service-worker, sentry, styles.css)
// already loaded successfully — the one condition that script exists to
// detect can no longer be true. This must run before anything else below,
// because a lazy-route chunk (JS or CSS) can still fail to load AFTER
// this point, and that failure belongs to lazy-with-reload.ts's one-time
// reload, not to a script that tears out the live React tree
// (JAVASCRIPT-REACT-4A, 2026-09-14: a failed booking-page stylesheet
// preload got caught by the old always-on listener, which wiped #root
// out from under an already-mounted React tree and crashed it for real).
window.__SWOS_APP_BOOTED__ = true;

// Error monitoring (no replay; PII-scrubbed). Must run before render so
// errors during the first paint are captured.
initSentry();

// PWA install support (home-screen app). Production-only no-op in dev.
registerServiceWorker();

const rootEl = document.getElementById("root");
if (!rootEl) {
  throw new Error("Missing #root element in index.html");
}

createRoot(rootEl).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
